import { render, staticRenderFns } from "./PCurrencyInput.vue?vue&type=template&id=fb18e8ee&scoped=true&"
import script from "./PCurrencyInput.vue?vue&type=script&lang=js&"
export * from "./PCurrencyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb18e8ee",
  null
  
)

export default component.exports